type Product = { hasAgeRestriction?: boolean }

type Category = {
  category: {
    hasAgeRestriction?: boolean
    products: Product[]
  }
}

export const hasRestrictedCategoriesValidation = ({ category }: Category) => {
  const restrictedCategory = Boolean(category?.hasAgeRestriction)

  const restrictedProduct = category?.products?.some((item: Product) =>
    Boolean(item.hasAgeRestriction)
  )

  return restrictedCategory || restrictedProduct
}
